import type { FaireProductEntity } from "../../entity_types/product";

export const p_43udfbsttu: FaireProductEntity = {
  token: "p_43udfbsttu",
  type: "product",
  name: "Cabin Time Games: Dodgeball (Wholesale Pack of 4)",
  brandToken: "b_qsh7rux99c",
  brandName: "Cabin Time Games",
  imageUrl: "https://cdn.faire.com/fastly/bf38c7d12cfb5d5d5a9c105846951769c2733532e7fdd3de0ad1afb4ad655f87.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c80b7f9027fe544a3ac9e00ad3364fac1698d26d7f4919733fdd1794058cef85.jpeg",
    "https://cdn.faire.com/fastly/fcf4faf20887170b3858ee1e6013844615146c0df6c5cc65d24dce57e1f1da37.png",
    "https://cdn.faire.com/fastly/f0ee78070fbcf38d8c266e21b5ed15aac6ee22da8fa72f71c6152262f0a3f1af.jpeg",
    "https://cdn.faire.com/fastly/1130176f29c45b05d392373381d4449b9f75a74f6db415b3a5e224f8ad801c52.png",
    "https://cdn.faire.com/fastly/42ae3d44081bd433417fdb6b5d46fe2a9992e03af3df1885dda7c8c59151a8a3.jpeg",
    "https://cdn.faire.com/fastly/e4ef1881680dc8cb3c721e72ae13a44eddb1ca523287f66f4af1a37602e05110.png",
    "https://cdn.faire.com/fastly/bab73aa6cfee9af85ab56d0d2e15685d5858ad6ad7e6c1563b1c2ea034688364.jpeg",
    "https://cdn.faire.com/fastly/228609a34d97b01705848d48b15b37993ff1fb518a65ab0e46efe6b2a9b44823.jpeg",
    "https://cdn.faire.com/fastly/c23b165222be2d97a6c18b20554ca8b72e3a39113639df4bffab792edbbb9fae.jpeg"
  ],
  priceDollars: 35.98,
  description: "Bring everyone into the action with Cabin Time Games: Dodgeball, a fast, screen free card game for kids and families. Players aim, dodge, defend, and recover as they try to be the last one standing. Quick turns and surprising plays make it easy to call for one more round.\n\nCreated by camp directors Allison Miller and Austin Nelson, Cabin Time Games: Dodgeball was tested and refined with real campers. This portable family game brings the fun of playing together to game nights, vacations, and everyday time together. Each boxed game includes a collectible patch.\n\nThis wholesale case contains 4 copies of Cabin Time Games: Dodgeball. Suggested retail price is $17.99 per game.",
  tags: [],
  msrpDollars: 71.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:37.532Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
